import { jsx as s } from "react/jsx-runtime";
import { Button as c } from "@chakra-ui/react";
import { forwardRef as d } from "react";
const m = d((o, e) => {
  const { children: t, isDestructive: r = !1, isFullWidth: i, ...n } = o;
  return /* @__PURE__ */ s(
    c,
    {
      ref: e,
      colorScheme: r ? "red" : void 0,
      w: i ? "100%" : void 0,
      loadingText: t,
      spinnerPlacement: "end",
      ...n,
      children: t
    }
  );
});
m.displayName = "Button";
export {
  m as Button
};
